import React, { useState } from "react";
import "./DealerPackagesSelector.scss";

const CategoryButton = ({ category, onClick, isActive }) => (
	<button
		onClick={() => onClick(category)}
		className={isActive ? "active" : ""}>
		{category}
	</button>
);

const ButtonContainer = ({ handleCategoryChange }) => {
	const [activeCategory, setActiveCategory] = useState("Move Up");

	const categories = [
		"Move Up",
		"Luxury",
		"Dynamic Inventory",
		"In-language",
	];

	const handleButtonClick = (category) => {
		setActiveCategory(category);
		handleCategoryChange(category);
	};

	return (
		<div className="packages-selector-container">
			<div className="button-container">
				{categories.map((category) => (
					<CategoryButton
						key={category}
						category={category}
						onClick={handleButtonClick}
						isActive={activeCategory === category}
					/>
				))}
			</div>
		</div>
	);
};

export default ButtonContainer;
